
export default {
  layout: 'default', // Use the default layout for this page
}
